export const GET_HOMEPAGE_BEGIN = "GET_HOMEPAGE_BEGIN";
export const GET_HOMEPAGE_SUCCESS = "GET_HOMEPAGE_SUCCESS";
export const GET_HOMEPAGE_ERROR = "GET_HOMEPAGE_ERROR";

export const SHOW_LOGIN_FORM = "SHOW_LOGIN_FORM";
export const HIDE_LOGIN_FORM = "HIDE_LOGIN_FORM";

export const SHOW_SIGNUP_FORM = "SHOW_SIGNUP_FORM";
export const HIDE_SIGNUP_FORM = "HIDE_SIGNUP_FORM";
